import React from 'react';

export default function GalagoLogo({ size = 32, className = '' }) {
  return (
    <img
      src="/assets/pwa-icon-192.png?v=2"
      alt=""
      width={size}
      height={size}
      className={className}
      style={{ width: size, height: size, objectFit: 'contain' }}
    />
  );
}
